import { render, staticRenderFns } from "./Articoli.vue?vue&type=template&id=1c02420e&scoped=true&"
import script from "./Articoli.vue?vue&type=script&lang=js&"
export * from "./Articoli.vue?vue&type=script&lang=js&"
import style0 from "./Articoli.vue?vue&type=style&index=0&id=1c02420e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c02420e",
  null
  
)

export default component.exports